import { render } from "./detail.vue?vue&type=template&id=28bd57ea&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=28bd57ea&scoped=true&lang=css"
import "./detail.vue?vue&type=style&index=1&id=28bd57ea&lang=css"
script.render = render
script.__scopeId = "data-v-28bd57ea"

export default script